import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import React from 'react';
import Hero from './Hero';

const Spinner = (props: { size?: string | number }) => {
  return (
    <Box sx={{ display: 'flex', '& > * + *': { ml: 2 } }}>
      <CircularProgress color="secondary" {...props} />
    </Box>
  );
};

interface OverlaySpinnerProps {
  relative?: boolean;
  overlay?: boolean;
  spinnerProps?: { size?: string | number };
}

const OverlaySpinner: React.FC<OverlaySpinnerProps> = ({
  relative,
  overlay = false,
  spinnerProps,
}) => {
  return (
    <Hero overlay={overlay} relative={relative}>
      <Spinner {...spinnerProps} />
    </Hero>
  );
};

export { OverlaySpinner, Spinner };

export default Spinner;
